export interface Colors {
  primary: string | null;
  primary_text: string | null;
}
